import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable} from 'rxjs';
import { environment } from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NotificationApi {

  api = environment.api;

  constructor(private http: HttpClient) { }


  getNotification(workspaceId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
    };
    return this.http.post(`${this.api}/Notification/GetNotifications`,bodyRequest);
  }

  deleteNotification(workspaceId, notificationId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      notificationIds: [notificationId],
    };
    return this.http.post(`${this.api}/Notification/DeleteNotifications`,bodyRequest);
  }

  updateSeenNotifications(workspaceId: string, notificationIds: any[]): Observable<any> {
    const bodyRequest = {
      workspaceId,
      notificationIds,
    };
    return this.http.post(`${this.api}/Notification/UpdateSeen`,bodyRequest);
  }
}
